/* eslint no-prototype-builtins: 0 */

class ObjectUtils {
    static getMaxSizeSubArray(obj) {
        let max = 0;
        Object.keys(obj).forEach((prop) => {
            if (obj[prop].constructor === Array && obj[prop].length > max)
                max = obj[prop].length;
        });
        return max;
    }

    static deepCompare() {
        let i, l, leftChain, rightChain;

        function compare2Objects(x, y) {
            let p;

            // remember that NaN === NaN returns false
            // and isNaN(undefined) returns true
            if (
                isNaN(x) &&
                isNaN(y) &&
                typeof x === "number" &&
                typeof y === "number"
            ) {
                return true;
            }

            // Compare primitives and functions.
            // Check if both arguments link to the same object.
            // Especially useful on the step where we compare prototypes
            if (x === y) {
                return true;
            }

            // Works in case when functions are created in constructor.
            // Comparing dates is a common scenario. Another built-ins?
            // We can even handle functions passed across iframes
            if (
                (typeof x === "function" && typeof y === "function") ||
                (x instanceof Date && y instanceof Date) ||
                (x instanceof RegExp && y instanceof RegExp) ||
                (x instanceof String && y instanceof String) ||
                (x instanceof Number && y instanceof Number)
            ) {
                return x.toString() === y.toString();
            }

            // At last checking prototypes as good as we can
            if (!(x instanceof Object && y instanceof Object)) {
                return false;
            }

            if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
                return false;
            }

            if (x.constructor !== y.constructor) {
                return false;
            }

            if (x.prototype !== y.prototype) {
                return false;
            }

            // Check for infinitive linking loops
            if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
                return false;
            }

            // Quick checking of one object being a subset of another.
            // todo: cache the structure of arguments[0] for performance
            for (p in y) {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                    return false;
                } else if (typeof y[p] !== typeof x[p]) {
                    return false;
                }
            }

            for (p in x) {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                    return false;
                } else if (typeof y[p] !== typeof x[p]) {
                    return false;
                }

                switch (typeof x[p]) {
                    case "object":
                    case "function":
                        leftChain.push(x);
                        rightChain.push(y);

                        if (!compare2Objects(x[p], y[p])) {
                            return false;
                        }

                        leftChain.pop();
                        rightChain.pop();
                        break;

                    default:
                        if (x[p] !== y[p]) {
                            return false;
                        }
                        break;
                }
            }

            return true;
        }

        if (arguments.length < 1) {
            return false;
        }

        for (i = 1, l = arguments.length; i < l; i++) {
            leftChain = []; //Todo: this can be cached
            rightChain = [];

            if (!compare2Objects(arguments[0], arguments[i])) {
                return false;
            }
        }

        return true;
    }

    static isJSON(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * Realiza una copia plana del objeto. Si el mismo contiene atributos de tipo coleccion las mismas
     * no seran copiadas, por lo tanto quedaran referenciando la misma coleccion.
     * Lo mismo para los atributos de tipo objeto, en la copia quedaran referenciando al mismo objeto
     * que el original.
     * Si obj no es un objeto se retornará el mismo obj
     *
     */
    static plainCopy(obj) {
        if (null == obj || "object" != typeof obj) return obj;
        return Object.assign({}, obj);
    }
}

export default ObjectUtils;
